import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4 mb-4 bg-white border shadow-lg dark:border-gray-200 dark:border dark:bg-gray-800 md:flex rounded-3xl border-clay-200" }
const _hoisted_2 = ["href", "alt", "title"]
const _hoisted_3 = ["src", "alt", "title"]
const _hoisted_4 = { class: "justify-between flex-1 ml-4 md:flex md:flex-col" }
const _hoisted_5 = { class: "items-center flex-none mb-2" }
const _hoisted_6 = ["href", "alt", "title"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "text-sm text-gray-900" }
const _hoisted_9 = { class: "tag-list" }
const _hoisted_10 = { class: "sr-only" }
const _hoisted_11 = ["href", "alt", "title"]
const _hoisted_12 = { class: "justify-between sm:flex" }
const _hoisted_13 = { class: "mt-2 ml-4 shrink-0 md:mt-0 md:pull-right md:float-right" }
const _hoisted_14 = { class: "grid grid-cols-2 mt-4 space-x-1 text-sm text-center sm:text-left sm:mt-0" }


import Bookmarking from "@/main/components/Bookmarking.vue";
import Fanning from "@/main/components/Fanning.vue";
import {CharacterDto} from "@/dtos";


export default /*@__PURE__*/_defineComponent({
  __name: 'CharacterCard',
  props: {
    character: {}
  },
  setup(__props: any) {

// @ts-ignore
const props = __props;

const character: CharacterDto = props.character;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: `/${_unref(character).urlSlug}`,
      alt: _unref(character).showTitle,
      title: _unref(character).showTitle,
      class: "shrink-0 guide-img-container"
    }, [
      _createElementVNode("img", {
        class: "object-cover w-20 h-20 mx-auto md:w-32 md:h-32 rounded-3xl",
        src: _unref(character).showLogo,
        alt: `${_unref(character).showTitle} logo`,
        title: `${_unref(character).showTitle} logo`
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: `/${_unref(character).urlSlug}`,
          alt: _unref(character).showTitle,
          title: _unref(character).showTitle,
          class: "inline-block text-sm font-medium text-gray-900 text-md hover:underline hover:decoration-slate-900 hover:transition-all hover:decoration-2 md:block"
        }, [
          _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(character).name), 1)
        ], 8, _hoisted_6),
        _createElementVNode("p", null, [
          _createElementVNode("em", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(character).roleSize) + "," + _toDisplayString(_unref(character).ageRanges?.join(',')) + " " + _toDisplayString(_unref(character).gender) + ", " + _toDisplayString(_unref(character).vocalParts?.join(',')) + " " + _toDisplayString(_unref(character).dancingLevel) + " " + _toDisplayString(_unref(character).ageRanges?.join(',')), 1)
            ])
          ])
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: `/${_unref(character).showId}`,
            alt: _unref(character).showTitle,
            title: _unref(character).showTitle,
            class: "text-sm text-slate-800"
          }, _toDisplayString(_unref(character).showTitle), 9, _hoisted_11)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mr-4" }, null, -1)),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(Fanning, {
                id: _unref(character).id,
                "number-of-fans": _unref(character).fanCount
              }, null, 8, ["id", "number-of-fans"]),
              _createVNode(Bookmarking, {
                id: _unref(character).id
              }, null, 8, ["id"])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})